module.exports = __webpack_public_path__ + "img/vsp0.aa88bedb.png";